import { BrowserRouter as Router, Navigate, Route, Routes, Outlet } from 'react-router';

import Footer from './components/Footer';
import config from '@/config';

import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import Chest from '@/pages/Chest';
import Referral from '@/pages/Referral';
import Rewards from '@/pages/rewards';
import WatchAccount from '@/components/WatchAccount';
import WatchReferral from '@/components/WatchReferral';
import ConnectionDebugger from '@/components/ConnectionDebugger';
import { RestrictedAccessGate } from '@/components/RestrictedAccessGate';
import { TutorialModal } from '@/components/TutorialModal';
import { useTutorial } from '@/hooks/useTutorial';
import { SeasonSummaryModal } from '@/components/SeasonSummaryModal';
import { useMultiSeasonSummary } from '@/hooks/useMultiSeasonSummary';
import { AppRoutesEnum } from '@/lib/constants';
import MyNFT from '@/pages/MyNFT';
import Points from '@/pages/Points';
import PreLaunch from '@/pages/PreLaunch';
import NFTGallery from '@/pages/nft-gallery';
import Wrapped from '@/pages/Wrapped';
import HolidayCampaign from '@/pages/HolidayCampaign';
import NewYearCampaign from '@/pages/NewYearCampaign';
import License from '@/pages/License';
import Privacy from '@/pages/Privacy';
import Copyright from '@/pages/Copyright';

function AppContent() {
  const { showTutorial, closeTutorial, completeTutorial } = useTutorial();
  const { showSummary, seasonId, markAsSeen } = useMultiSeasonSummary();

  return (
    <>
      <WatchAccount />
      <WatchReferral />
      <ConnectionDebugger />

      <TutorialModal
        open={showTutorial}
        onClose={closeTutorial}
        onComplete={completeTutorial}
      />

      <SeasonSummaryModal
        open={showSummary}
        onClose={markAsSeen}
        seasonId={seasonId ?? 1}
      />

      <Routes>
        {/* Public routes - no guard */}
        <Route path={AppRoutesEnum.PreLaunch} element={<PreLaunch />} />
        <Route path={AppRoutesEnum.HolidayCampaign} element={<HolidayCampaign />} />
        {config.ENABLE_NEW_YEAR_CAMPAIGN && (
          <Route path={AppRoutesEnum.NewYearCampaign} element={<NewYearCampaign />} />
        )}
        <Route path={AppRoutesEnum.License} element={<License />} />
        <Route path={AppRoutesEnum.Privacy} element={<Privacy />} />
        <Route path={AppRoutesEnum.Copyright} element={<Copyright />} />

        {/* Protected routes - PreLaunchGuard disabled */}
        <Route element={
          // <PreLaunchGuard>
            <RestrictedAccessGate>
              <div className="flex-1">
                <Outlet />
              </div>
            </RestrictedAccessGate>
          // </PreLaunchGuard>
        }>
          <Route path={AppRoutesEnum.Home} element={<Home />} />
          <Route path={AppRoutesEnum.Chest} element={<Chest />} />
          <Route path={AppRoutesEnum.Points} element={<Points />} />
          <Route path="/points-lottery" element={<Navigate to={AppRoutesEnum.Points} replace />} />
          <Route path={AppRoutesEnum.Referral} element={<Referral />} />
          <Route path={AppRoutesEnum.Rewards} element={<Rewards />} />
          <Route path={AppRoutesEnum.MyNFT} element={<MyNFT />} />
          <Route path={AppRoutesEnum.NFTGallery} element={<NFTGallery />} />
          <Route path={AppRoutesEnum.Wrapped} element={<Wrapped />} />
          <Route path="*" element={<Navigate to={AppRoutesEnum.Home} replace />} />
        </Route>
      </Routes>
      
      <Toaster position="top-right" />
      <Footer />
    </>
  );
}

function AppRouter() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default AppRouter;
